import {
  _sharedActionsSystem,
  _sharedActionsConstantsSystem
} from "@/shared/store/system/actions";

export const systemActionsConstants = {
  ..._sharedActionsConstantsSystem,
  SET_SHOW_SIDE_MENU: "SET_SHOW_SIDE_MENU",
  SET_SHOW_SEARCH_PANEL: "SET_SHOW_SEARCH_PANEL",
  SET_SHOW_ADV_SEARCH_PANEL: "SET_SHOW_ADV_SEARCH_PANEL",
  SET_SHOW_PANEL_BOOK_TRANSLATIONS: "SET_SHOW_PANEL_BOOK_TRANSLATIONS",
  SET_SHOW_PANEL_BOOK_CONTENTS: "SET_SHOW_PANEL_BOOK_CONTENTS",
  ACTION_HIDE_ALL: "ACTION_HIDE_ALL",
  ACTION_COPY: "ACTION_COPY",
};

export const systemActions = {
  ..._sharedActionsSystem,
  setShowSearchPanel: (data) => ({
    type: systemActionsConstants.SET_SHOW_SEARCH_PANEL,
    data,
  }),
  setShowPanelBookTranslations: (data) => ({
    type: systemActionsConstants.SET_SHOW_PANEL_BOOK_TRANSLATIONS,
    data,
  }),
  setShowPanelBookContents: (data) => ({
    type: systemActionsConstants.SET_SHOW_PANEL_BOOK_CONTENTS,
    data,
  }),
  setShowAdvSearchPanel: (data) => ({
    type: systemActionsConstants.SET_SHOW_ADV_SEARCH_PANEL,
    data,
  }),
  setShowSideMenu: (data) => ({
    type: systemActionsConstants.SET_SHOW_SIDE_MENU,
    data,
  }),
  actionHideAll: () => ({
    type: systemActionsConstants.ACTION_HIDE_ALL,
  }),
  /**
   * @param text
   * @param {{
   *   noToast?: boolean,
   *   successMessage?: string,
   *   errorMessage?: string,
   * }} options
   */
  actionCopy: (text, options = {}) => ({
    type: systemActionsConstants.ACTION_COPY,
    data: { text, options },
  }),
};
